
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/mercadopago",
      function () {
        return require("private-next-pages/auth/mercadopago.js");
      }
    ]);
  